import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_CATEGORIES_SECTEUR} from "../constants/endpoints";

let store = {
  debug: true,
  state: {
    categoriesSecteur: []
  },

  getAll() {
    if (this.state.categoriesSecteur.length === 0) {
      return axios.get(ENDPOINT_CATEGORIES_SECTEUR)
          .then(response => {
            this.state.categoriesSecteur = response.data;
            return this.state.categoriesSecteur;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.categoriesSecteur);
      });
    }
  }
};

export default store;
